import type { SxProps, Theme } from "@mui/material/styles";
import { colors, alphaVar } from "../../ui/colors";

/**
 * Matches JobEventRow "Invoice" / "Edit" text buttons (height 32, 8px radius, orange/blue/gray tones).
 */
const base: SxProps<Theme> = {
  height: 32,
  borderRadius: "8px",
  fontSize: "0.75rem",
  fontWeight: 600,
  textTransform: "none",
  px: 1.5,
  minWidth: "auto",
  transition: "all 0.15s ease",
  "&:active": { transform: "scale(0.97)" },
};

export type DepositTriggerTone = "pending" | "success" | "muted";

/** Deposit cell + modal actions: same visual language as `JobEventRow` invoice/create buttons. */
export function getDepositTriggerButtonSx(tone: DepositTriggerTone): SxProps<Theme> {
  switch (tone) {
    case "success":
      return {
        ...base,
        color: colors.success[600],
        bgcolor: alphaVar(colors.success[100], 0.5),
        "&:hover": { bgcolor: colors.success[100], color: colors.success[700] },
      };
    case "muted":
      return {
        ...base,
        color: colors.gray[600],
        bgcolor: alphaVar(colors.gray[100], 0.5),
        "&:hover": { bgcolor: colors.gray[100], color: colors.gray[700] },
      };
    default:
      return {
        ...base,
        color: colors.orange[600],
        bgcolor: alphaVar(colors.orange[100], 0.5),
        "&:hover": { bgcolor: colors.orange[100], color: colors.orange[700] },
      };
  }
}

/** Primary "Create / Issue deposit invoice" action in the deposit modal (orange, like Create Invoice). */
export const issueDepositInvoiceButtonSx: SxProps<Theme> = getDepositTriggerButtonSx("pending");
